import Alert, { AlertColor } from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import Snackbar, { SnackbarCloseReason } from "@mui/material/Snackbar";
import { SyntheticEvent } from "react";
import { atom, useRecoilState } from "recoil";

export interface CustomSnackbarState {
    message: string;
    isOpen: boolean;
    severity: AlertColor;
    duration?: number;
}

export const customAlertState = atom({
    key: "alertState",
    default: {} as CustomSnackbarState,
});

const CustomSnackbar = () => {
    const [alertState, setAlertState] = useRecoilState(customAlertState);

    if (!alertState.message) {
        return null;
    }

    return (
        <Snackbar
            sx={{ width: "100%" }}
            open={alertState.isOpen}
            autoHideDuration={alertState.duration ? alertState.duration : 3000}
            onClose={(event, reason) => closeSnackbarHandler(event, reason)}
            TransitionComponent={(props) => <Slide {...props} direction="up" />}
        >
            <Alert onClose={closeSnackbarHandler} severity={alertState.severity} sx={{ maxWidth: "40%", lineBreak: "anywhere" }}>
                {alertState.message}
            </Alert>
        </Snackbar>
    );

    function closeSnackbarHandler(event: Event | SyntheticEvent<Element, Event>, reason?: SnackbarCloseReason) {
        if (reason !== "clickaway" && reason !== "escapeKeyDown") {
            setAlertState({ isOpen: false, message: "", severity: "info" });
        }
    }
};

export default CustomSnackbar;
